import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import "./Tabination.css";
import useResponsive from "../../../hooks/useResponsive";
import { contactWiseDetailTabs } from "../../../pages/Contact/ContactDetails/ContactDetails";

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};


interface TabinationProps {
  tabs: contactWiseDetailTabs[];
  handleTabChange: (event: React.SyntheticEvent, newValue: string) => void;
  tabView: any;
}

const Tabination: React.FC<TabinationProps> = ({ tabs, handleTabChange, tabView }) => {
  const isMobile = useResponsive();

  const tabStyle = {
    fontWeight: "500",
    fontSize: isMobile ? "12px" : "14px",
    padding: isMobile ? 0 : "auto",
    color: "#000",
    textTransform: "capitalize",
    fontFamily: '"Plus Jakarta Sans", sans-serif',
    "&.Mui-selected": { color: "#00A4E5" },
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          marginLeft: "10px",
          marginRight: "10px",
        }}
      >
        <Tabs className="headMainTab"
          value={tabView}
          TabIndicatorProps={{
            style: {
              backgroundColor: '#00a4e5',
            },
          }}
          onChange={handleTabChange}
          aria-label="basic tabs example"
        >
          {tabs.map((tab, index) => {
            return (
              <Tab className="headTabBtn"
                value={tab.value}
                key={index}
                label={tab.label}
                {...a11yProps(index)}
                sx={tabStyle}
              />
            );
          })}
        </Tabs>
      </Box>
    </Box>
  );
};

export default Tabination;
